interface CustomIconPushNotificationSharingProps extends React.SVGProps<SVGSVGElement> {}

export function CustomIconPushNotificationSharing({
  width,
  height,
  className,
  color = '#1C1C28',
}: CustomIconPushNotificationSharingProps) {
  return (
    <svg
      className={className}
      width={width || 32}
      height={height || 32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.8308 6.94909C12.0559 7.51175 11.7822 8.15034 11.2195 8.37541C8.32251 9.53421 6.42287 12.34 6.42287 15.4602V20.3358C6.42287 20.6578 6.33536 20.9738 6.1697 21.2499L5.61768 22.1699H23.4307C24.0367 22.1699 24.528 22.6612 24.528 23.2672C24.528 23.8732 24.0367 24.3645 23.4307 24.3645H4.87939C3.49849 24.3645 2.64555 22.858 3.35601 21.6739L4.22831 20.22V15.4602C4.22831 11.4427 6.67429 7.82988 10.4045 6.33781C10.9671 6.11274 11.6057 6.38642 11.8308 6.94909Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2797 6.94909C15.0547 7.51175 15.3284 8.15034 15.891 8.37541C18.788 9.53421 20.6877 12.34 20.6877 15.4602V20.3358C20.6877 20.6578 20.7752 20.9738 20.9408 21.2499L22.49 23.8317C22.8018 24.3514 23.4758 24.5199 23.9954 24.2081C24.5151 23.8963 24.6836 23.2223 24.3718 22.7026L22.8822 20.22V15.4602C22.8822 11.4427 20.4363 7.82988 16.7061 6.33781C16.1434 6.11274 15.5048 6.38642 15.2797 6.94909Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.4479 6.65406C14.0103 6.04139 13.0998 6.04139 12.6621 6.65406L11.7047 7.99444L9.91895 6.71888L10.8764 5.3785C12.1892 3.5405 14.9209 3.5405 16.2337 5.3785L17.1911 6.71888L15.4053 7.99444L14.4479 6.65406Z"
        fill={color}
      />
      <circle cx="19.5906" cy="12.843" r="3.84048" fill="white" stroke={color} strokeWidth="2.19456" />
      <path
        d="M11.3608 23.8159V23.8159C11.3608 25.3309 12.589 26.5591 14.104 26.5591V26.5591C15.6191 26.5591 16.8472 25.3309 16.8472 23.8159V23.8159"
        stroke={color}
        strokeWidth="2.19456"
      />
    </svg>
  );
}
